var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-w",staticStyle:{"height":"100%","overflow":"auto"}},[_c('goods-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }